import { CloseIconProps } from './close-icon.props';
import React from 'react';

export const CloseIconMolecule = (props: CloseIconProps) => {
  return (
    <div
      data-cy="close-icon-molecule"
      className={`cursor-pointer flex justify-center items-center ${props.className}`}
    >
      <img
        onClick={props.close}
        src={props.closeIconSrc}
        className="w-full"
        alt="Close icon"
      />
    </div>
  );
};

CloseIconMolecule.defaultProps = {
  closeIconSrc: '/images/icons/blue-close-icon.svg',
};
